import React from 'react';
import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent, TextField, Button, Box } from '@mui/material';
import { IoMdTrash } from 'react-icons/io';
import { ParamBoxDiv } from './styles';
import { Parameter } from '../../types/Process.d';

interface ParamBoxProps {
  parameter: Parameter;
  onChange: () => void;
  onDelete: (parameter: Parameter) => void;
}

const ParamBox: React.FC<ParamBoxProps> = ({ parameter, onChange, onDelete }) => {
  const param = parameter;

  function onChangeAbbreviation(event: React.ChangeEvent<HTMLInputElement>) {
    param.abbreviation = event.target.value;
    onChange();
  }

  function onChangeType(event: SelectChangeEvent<string>) {
    param.type = event.target.value;
    onChange();
  }

  function onChangeDescription(event: React.ChangeEvent<HTMLInputElement>) {
    param.description = event.target.value;
    onChange();
  }

  return (
    <ParamBoxDiv>
      <Button
        sx={{ float: 'right', padding: 0, minWidth: '20px' }}
        onClick={() => {
          onDelete(parameter);
        }}
        type='button'
      >
        <IoMdTrash size={20} />
      </Button>

      <Box sx={{ display: 'flex', padding: '0.5rem' }}>
        <TextField
          fullWidth
          label='Nome abreviado'
          id='abbreviation'
          name='abbreviation'
          type='text'
          onChange={onChangeAbbreviation}
          value={param.abbreviation}
          required
        />

        <FormControl sx={{ minWidth: '100px', marginLeft: '1rem' }}>
          <InputLabel>Tipo</InputLabel>
          <Select label='Tipo' id='type' name='type' onChange={onChangeType} value={param.type} required>
            <MenuItem value='boolean'>SIM/NÃO</MenuItem>
            <MenuItem value='string'>TEXTO</MenuItem>
            <MenuItem value='number'>NUMÉRICO</MenuItem>
          </Select>
        </FormControl>
      </Box>

      <Box sx={{ display: 'flex', padding: '0.5rem' }}>
        <TextField
          label='Descrição'
          id='description'
          name='description'
          fullWidth
          onChange={onChangeDescription}
          value={param.description}
        />
      </Box>
    </ParamBoxDiv>
  );
};

export default ParamBox;
